/** Hero search-bar field label. */
export default function SearchField({ label, icon, children }) {
  return (
    <label className="block">
      <span className="flex items-center gap-1.5 text-[10px] uppercase tracking-[0.25em] text-neutral-500 mb-1.5">
        {icon} {label}
      </span>
      {children}
    </label>
  );
}
